module.exports = __webpack_public_path__ + "img/root011.801d7927.png";